import { MobileAppPage } from "@/components/mobile-app-page";
import { IOS_FAQ_KEYS } from "@/pages/beancount-ios-content";

export function BeancountIosComponent() {
  return <MobileAppPage platform="ios" faqs={IOS_FAQ_KEYS} />;
}
